import { PageStepper } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useFeatureFlagEnabled } from "posthog-js/react";

import { MESSAGES } from "./message-definitions";
import { OnboardingStepperNext } from "./onboarding-stepper-next";

const STEP_MAPPING: Record<number, number> = {
  4: 3,
  5: 4,
};

export const OnboardingStepper = ({ currentStep }: { currentStep: number }) => {
  const intl = useIntl();
  const isNewOnboardingSetupFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");

  if (isNewOnboardingSetupFlowEnabled) {
    const mappedStep = STEP_MAPPING[currentStep] ?? currentStep;
    return <OnboardingStepperNext currentStep={mappedStep} />;
  }

  const ONBOARDING_STEPS = [
    intl.formatMessage(MESSAGES.stepBusinessInformation),
    intl.formatMessage(MESSAGES.stepContactDetails),
    intl.formatMessage(MESSAGES.stepMonthlyRevenue),
    intl.formatMessage(MESSAGES.stepFundingDetails),
    intl.formatMessage(MESSAGES.stepConnectionsAndData),
    intl.formatMessage(MESSAGES.stepApplicationReview),
  ];

  return <PageStepper currentIndex={currentStep} steps={ONBOARDING_STEPS} maxVisibleSteps={ONBOARDING_STEPS.length} />;
};
